export const heroData = {
  name: "Аполлинария Шутова",
  subtitle: "Клинический и кризисный психолог",
  specialization: "Специалист по психосоматике",
  imageUrl: "https://customer-assets.emergentagent.com/job_4b8afc43-a8f9-4945-9e8d-6bc97f7e337b/artifacts/crpdkidb_IMG_2811.JPG"
};

export const approachData = {
  lines: [
    "Вы можете многое понимать — но не чувствовать реальных изменений.",
    "Работа со мной происходит на трёх уровнях: через тело, состояние и психику.",
    "Именно так запускаются изменения, которые остаются с вами."
  ]
};

export const situations = [
  {
    number: "01",
    title: "Психосоматика",
    text: "У вас есть симптомы или диагноз, но лечение не даёт результата. Врачи разводят руками или говорят «это на нервной почве».\n\nВы чувствуете, что тело сигналит о чём-то глубже — и важно не просто убрать симптом, а понять причину."
  },
  {
    number: "02",
    title: "Тревожные состояния и бессонница",
    text: "Вы постоянно находитесь в напряжении. Мысли не останавливаются, тело не расслабляется.\n\nТревога становится фоном жизни: сложно заснуть, сложно выдохнуть, сложно быть в спокойствии."
  },
  {
    number: "03",
    title: "Потеря опоры и состояния гармонии в жизни",
    text: "Вы не понимаете, куда двигаться дальше. Есть ощущение внутренней пустоты или растерянности.\n\nРаньше было больше энергии, ясности, уверенности — сейчас будто потерян контакт с собой."
  },
  {
    number: "04",
    title: "Отношения",
    text: "Сложности с партнёром, конфликты, повторяющиеся сценарии. Боль, обиды, зависимость или страх быть в близости.\n\nВы хотите понять себя в отношениях и начать выстраивать их по-другому."
  },
  {
    number: "05",
    title: "Кризисные ситуации",
    text: "Развод, расставание, болезнь, потеря, резкие изменения в жизни или состоянии.\n\nВы находитесь в точке, где сложно справляться самостоятельно и важно не «сломаться», а пройти это осознанно."
  },
  {
    number: "06",
    title: "Самореализация и внутренний тупик",
    text: "Вы чувствуете, что живёте не свою жизнь. Есть выгорание, отсутствие смысла, непонимание, куда дальше.\n\nХочется большего — но нет состояния, из которого можно двигаться."
  }
];

export const situationsClosing = "Если вы узнали себя хотя бы в одном из пунктов — это уже точка, с которой можно начать работу.";

export const aboutData = {
  name: "Аполлинария Шутова",
  role: "Клинический и кризисный психолог, специалист по психосоматике",
  paragraphs: [
    { text: "Работаю с внутренними состояниями через тело и психику — помогаю не только понять, но и прожить и изменить причины того, что с вами происходит.", bold: false },
    { text: "Мой подход — интегративный.\nВ работе я соединяю современные методы психологии, телесные практики, дыхательные техники и элементы гипнотерапии.", bold: false },
    { text: "Регулярно обучаюсь и обновляю свои знания, чтобы работать с актуальными и эффективными инструментами.", bold: false },
    { text: "Мой приоритет в работе — чтобы изменения были не временными, а устойчивыми.", bold: true },
    { text: "Создаю безопасное, бережное и конфиденциальное пространство, в котором возможны реальные изменения.", bold: false },
    { text: "Для каждого клиента подбирается индивидуальный формат работы — под запрос, состояние и глубину процесса.", bold: false }
  ],
  imageUrl: "https://customer-assets.emergentagent.com/job_4b8afc43-a8f9-4945-9e8d-6bc97f7e337b/artifacts/cwfuw1mm_IMG_2810.JPG"
};

export const statsData = [
  { number: "3+", label: "года практики" },
  { number: "1200+", label: "часов глубокой работы с клиентами" },
  { number: "200+", label: "человек прошли через индивидуальную работу" }
];

export const benefitsData = {
  title: "Что вам даст работа со мной",
  subtitle: "Результаты, которые вы начинаете чувствовать уже в процессе работы",
  items: [
    {
      number: "01",
      text: "Вы начнёте видеть, что на самом деле стоит за вашим состоянием — не на уровне теории, а через личный опыт и проживание."
    },
    {
      number: "02",
      text: "Снизится уровень внутреннего напряжения и фоновой тревоги — через работу с телом и нервной системой."
    },
    {
      number: "03",
      text: "Появится контакт с собой — своими чувствами, желаниями и внутренней опорой."
    },
    {
      number: "04",
      text: "Вы научитесь принимать решения не из страха и напряжения, а из ясности и устойчивого состояния."
    },
    {
      number: "05",
      text: "Изменения начнут проявляться не только внутри, но и в ваших действиях и реальной жизни — и останутся с вами."
    },
    {
      number: "06",
      text: "Вы начнёте жить более качественную, здоровую и счастливую жизнь."
    }
  ]
};

export const resultBlock = {
  title: "Результат возможен всегда.",
  lines: [
    "Но он напрямую зависит от вашей готовности быть в процессе и брать ответственность за изменения."
  ]
};

export const afterPricingBlock = {
  lines: [
    "Работа с собой всегда даёт результат — если вы действительно готовы к изменениям.",
    "Иногда достаточно одной сессии, чтобы увидеть решение.",
    "Но более глубокие запросы требуют времени и совместной работы.",
    "Формат всегда подбирается индивидуально — под ваш запрос и ваше состояние."
  ]
};

export const faqData = [
  {
    question: "Сколько сессий мне понадобится?",
    answer: "Всё индивидуально.\nИногда достаточно 1–2 встреч для решения конкретного ситуационного запроса.\nБолее глубокие изменения требуют более длительной и последовательной работы."
  },
  {
    question: "Можно ли решить мой запрос за одну консультацию?",
    answer: "В некоторых случаях — да.\nНо если речь идёт о глубинных состояниях и повторяющихся сценариях, для устойчивых изменений потребуется время."
  },
  {
    question: "Как понять, подойдёт ли мне работа с вами?",
    answer: "Вы можете написать мне, и мы обсудим ваш запрос.\nЯ помогу определить формат работы, который подойдёт именно вам."
  },
  {
    question: "В каком формате проходят консультации?",
    answer: "Консультации проходят онлайн в формате видеосвязи.\nДень и время мы согласовываем заранее."
  },
  {
    question: "Что если я не знаю, с чем именно хочу работать?",
    answer: "Это нормально.\nМы можем вместе сформулировать ваш запрос уже в процессе первой встречи."
  }
];

export const pricing90 = [
  {
    id: "90-single",
    name: "Консультация",
    duration: "90 минут",
    price: "55",
    currency: "\u20AC",
    paymentUrl: "https://secure.wayforpay.com/button/b2661d9ae8b4c"
  },
  {
    id: "90-base",
    name: "База",
    duration: "3 консультации по 90 минут",
    price: "150",
    currency: "\u20AC",
    paymentUrl: "https://secure.wayforpay.com/button/bb573772b3746"
  },
  {
    id: "90-baseplus",
    name: "База+",
    duration: "5 консультаций по 90 минут",
    price: "255",
    currency: "\u20AC",
    paymentUrl: "https://secure.wayforpay.com/button/bfc9747ae6bc1"
  },
  {
    id: "90-depth",
    name: "Твоя глубина",
    duration: "10 консультаций по 90 минут",
    price: "525",
    currency: "\u20AC",
    paymentUrl: "https://secure.wayforpay.com/button/bc31a5bef9f2c"
  }
];

export const pricing60 = [
  {
    id: "60-single",
    name: "Консультация",
    duration: "60 минут",
    price: "40",
    currency: "\u20AC",
    paymentUrl: "https://secure.wayforpay.com/button/b8c894dd7cfdb"
  },
  {
    id: "60-base",
    name: "База",
    duration: "3 консультации по 60 минут",
    price: "115",
    currency: "\u20AC",
    paymentUrl: "https://secure.wayforpay.com/button/bebdf15b05192"
  },
  {
    id: "60-baseplus",
    name: "База+",
    duration: "5 консультаций по 60 минут",
    price: "185",
    currency: "\u20AC",
    paymentUrl: "https://secure.wayforpay.com/button/b0c67afe619fe"
  },
  {
    id: "60-depth",
    name: "Твоя глубина",
    duration: "10 консультаций по 60 минут",
    price: "380",
    currency: "\u20AC",
    paymentUrl: "https://secure.wayforpay.com/button/b644355f0c6c0"
  }
];

export const testimonials = [
  {
    id: 1,
    imageUrl: "https://customer-assets.emergentagent.com/job_promo-portfolio-4/artifacts/jiy7rg46_2025-10-20%2013.08.35.jpg"
  },
  {
    id: 2,
    imageUrl: "https://customer-assets.emergentagent.com/job_promo-portfolio-4/artifacts/c7i47bm9_2025-10-20%2013.09.06.jpg"
  },
  {
    id: 3,
    imageUrl: "https://customer-assets.emergentagent.com/job_promo-portfolio-4/artifacts/xqk2rujn_2025-10-20%2013.09.11.jpg"
  },
  {
    id: 4,
    imageUrl: "https://customer-assets.emergentagent.com/job_promo-portfolio-4/artifacts/phdp8sf3_2025-10-20%2013.08.41.jpg"
  },
  {
    id: 5,
    imageUrl: "https://customer-assets.emergentagent.com/job_promo-portfolio-4/artifacts/2pjp78ws_2025-10-20%2013.08.55.jpg"
  },
  {
    id: 6,
    imageUrl: "https://customer-assets.emergentagent.com/job_promo-portfolio-4/artifacts/rxxyqvbc_2025-10-20%2013.09.02.jpg"
  },
  {
    id: 7,
    imageUrl: "https://customer-assets.emergentagent.com/job_promo-portfolio-4/artifacts/um8b7a8f_2025-10-20%2013.09.17.jpg"
  }
];

export const contactInfo = {
  instagram: "@apollinariashutova",
  instagramUrl: "https://instagram.com/apollinariashutova?igshid=MjEwN2IyYWYwYw==",
  telegram: "@ApollinarisSh",
  telegramUrl: "https://t.me/ApollinarisSh",
  website: "apollinariiapsychology.com"
};
